import SectionContainer from "../components/SectionContainer";
import FaqItem from "../components/FaqItem";

const FAQS = [
  {
    question: "Does Shadow train on my data?",
    answer:
      "No. Your meeting data is never used to train any models. Recordings and transcripts stay yours and are encrypted in transit and at rest.",
  },
  {
    question: "Can I try it for free before starting?",
    answer:
      "Yes. The Starter plan is free forever and includes 10 meetings per month, real-time action detection, and follow-up scheduling.",
  },
  {
    question: "What languages and apps are supported?",
    answer:
      "Shadow understands 60+ languages and works with Slack, Google Meet, Zoom, Microsoft Teams, Notion, and most major work tools.",
  },
  {
    question: "What tools does Shadow work with?",
    answer:
      "Shadow connects to your CRM, calendar, docs, and project management tools and takes action without you switching tabs.",
  },
];

export default function FaqsSection() {
  return (
    <SectionContainer id="faqs" className="py-20 sm:py-28">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <h2 className="text-[clamp(2rem,5vw,3.5rem)] font-semibold tracking-tight text-neutral-900">
            FAQs
          </h2>
        </div>
        <div className="lg:col-span-8">
          {FAQS.map((faq) => (
            <FaqItem key={faq.question} {...faq} />
          ))}
        </div>
      </div>
    </SectionContainer>
  );
}
